import { render, staticRenderFns } from "./commonHuman.vue?vue&type=template&id=43a774bd&scoped=true"
import script from "./commonHuman.vue?vue&type=script&lang=js"
export * from "./commonHuman.vue?vue&type=script&lang=js"
import style0 from "./commonHuman.vue?vue&type=style&index=0&id=43a774bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a774bd",
  null
  
)

export default component.exports